var React = require('react');

function ContentBarn (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-barn"),React.createElement("path",{"d":"M66.11 20.88a34.63 34.63 0 0110.2 24.49v30.32a3.06 3.06 0 01-3.22 3.05H9.92a3.06 3.06 0 01-3.06-3.21V45.37a34.73 34.73 0 0159.25-24.49zm-44.1 51.75V49.31a3.05 3.05 0 013.21-3h32.89a3.06 3.06 0 013 3v23.32h9V45.37a28.61 28.61 0 00-57.22 0v27.26zm33 0V52.37H28.12v20.26zm9.35-69.62c0-4 6.11-4 6.11 0v9.7A41.42 41.42 0 0183 31.03c1.26 3.81-4.52 5.71-5.78 1.93C72.17 17.83 57.27 8.29 41.59 8.29S11 17.84 5.96 32.96c-1.26 3.78-7 1.88-5.78-1.93C6.06 13.37 23.27 2.18 41.59 2.18A44.85 44.85 0 0164.4 8.37z","key":1})]);
}

ContentBarn.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 83.17 78.74"};

module.exports = ContentBarn;

ContentBarn.default = ContentBarn;
